import { Directive } from '@angular/core';

/**
 * Directive that styles tab group elements to be used as tab switchers.
 */
@Directive({
    selector: 'mat-tab-group[tabSwitcher]',
    standalone: true,
    host: { class: 'tab-switcher' },
})
export class TabSwitcherDirective
{
}

/**
 * A directive that applies primary styling to a Material tab group component.
 */
@Directive({
    selector: 'mat-tab-group[tabPrimary]',
    standalone: true,
    host: { class: 'tab-primary' },
})
export class TabPrimaryDirective
{
}
